module.exports = __webpack_public_path__ + "media/images/emblems/Le_Chatelard_FR-coat_of_arms-c4d0e78cc65163515da456217985fb84.svg";